
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product-picker/[slug]/[question]",
      function () {
        return require("private-next-pages/product-picker/[slug]/[question].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product-picker/[slug]/[question]"])
      });
    }
  